import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";

async function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

const useFetchImgs = (img1Path, img2Path) => {
  const [results, setResults] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const { instance, accounts } = useMsal();
  const [bearerToken, setBearerToken] = useState("");
  const url =
    "https://6qqebndh1k.execute-api.us-east-1.amazonaws.com/simulation/getimgs";

  useEffect(() => {
    const accessTokenRequest = {
      scopes: loginRequest.scopes,
      account: accounts[0],
    };

    instance
      .acquireTokenSilent(accessTokenRequest)
      .then((accessTokenResponse) => {
        setBearerToken(accessTokenResponse.accessToken);
      });
  });

  useEffect(() => {
    const fetchData = async () => {
      if (!bearerToken) {
        return; // Wait until the token is acquired before fetching presigned urls
      }
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${bearerToken}`,
          },
          body: JSON.stringify({
            imgSrc1: img1Path,
            imgSrc2: img2Path,
          }),
        });
        const data = await response.json();
        // await sleep(2000);
        setResults(data);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [img1Path, img2Path, bearerToken]);

  return { results, loading, error };
}

export default useFetchImgs;